/** Executive Minimal page header — title · context · actions.
 *  Replaces the ad-hoc "h1 + h2 + subtitle + buttons" idiom used across the app. */
export default function PageHeader({ eyebrow, title, context, actions, children, testId }) {
  return (
    <header className="st-page-header" data-testid={testId}>
      <div className="min-w-0 flex-1 basis-[18rem]">
        {eyebrow && <div className="st-overline mb-1">{eyebrow}</div>}
        <h1 className="st-page-title truncate">{title}</h1>
        {context && <div className="st-page-context">{context}</div>}
        {children}
      </div>
      {actions && <div className="flex min-w-0 max-w-full flex-wrap items-center justify-end gap-2 [&>div]:flex-wrap [&>div]:justify-end" data-testid={testId ? `${testId}-actions` : undefined}>{actions}</div>}
    </header>
  );
}
